export default __webpack_public_path__ + "static/media/ic-test-1.292b62cb.svg";